module.exports = __webpack_public_path__ + "img/顶部背景图.7a34c5d3.png";